export default () => {
  const meta = document.createElement('meta');
  meta.httpEquiv = 'robots';
  meta.content = 'noindex';
  document.getElementsByTagName('head')[0].appendChild(meta);
};
